import { get, isNull } from 'lodash'

interface BEError {
  data: {
    errors: {
      defaultMessage: string
    }[]
  }
}

export const formatBEError = (codes: string[] = [], error: BEError = {} as BEError) => {
  if (isNull(codes)) {
    return ''
  }

  const errors = get(error, 'data.errors', [])
  const errorObject = errors.find(({ defaultMessage }) => codes.find(code => defaultMessage.includes(code)))

  return errorObject ? errorObject.defaultMessage.split('::')[1] || '' : ''
}
